"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsInMigration = void 0;
var selectIsInMigration = function (state, partnerKey) {
    var _a, _b, _c;
    return Boolean((_c = (_b = (_a = state.supplyMigration) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.integrationKeysToMigrate) === null || _c === void 0 ? void 0 : _c.includes(partnerKey));
};
exports.selectIsInMigration = selectIsInMigration;
